import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  Modal,
  Button,
  Form,
  Input,
  Table,
  Row,
  Tag,
  Divider,
  Select,
  Popconfirm,
  notification,
} from "antd";
import { useLoading } from "../../context/loadingContext";
import GetVatMerchants from "../../functions/merchant/getVatMerchant";
import MerchantAddEdit from "../../components/modal/merchantAddEdit";
import SearchMerchant from "../../components/search/searcMerchant";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import DeleteVatMerchant from "../../functions/merchant/deleteVatMerchant";
import { bg_button } from "constant/css";
import { getMerchantId } from "service/storage";

const MerchantVatMerchant = () => {
  const [editingMerchantId, setEditingMerchantId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [merchants, setMerchants] = useState([]);
  const [paginationData, setPaginationData] = useState({});
  const merchantId = getMerchantId();
  const [query, setQuery] = useState({});
  const { showLoading, hideLoading } = useLoading();
  const handleShow = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const search = async (queryObject) => {
    const queryString = Object.keys(queryObject)
      .map((key) => `${key}=${encodeURIComponent(queryObject[key])}`)
      .join("&");
    setQuery(queryObject);
    fetchVatMerchant(queryString);
  };

  const columns = [
    {
      title: "#",
      render: (t, r, index) => index + 1,
      width: 60,
      fixed: "left",
    },
    {
      title: (
        <SearchMerchant
          query={query}
          title="Нэр"
          fieldName="name"
          search={search}
        />
      ),
      dataIndex: "name",
      key: "name",
      fixed: "left",
      width: 250,
    },
    {
      title: (
        <SearchMerchant
          query={query}
          title="Регистр"
          fieldName="register"
          search={search}
        />
      ),
      dataIndex: "register",
      key: "register",
      width: 150,
    },
    {
      title: (
        <SearchMerchant
          query={query}
          select={[
            { value: "ALL", title: "Сонго" },
            { value: "VAT_ABLE", title: "НӨАТ Төлөгч" },
            { value: "VAT_FREE", title: "НӨАТ Төлөгч биш" },
          ]}
          title="Татварын төрөл"
          fieldName="taxType"
          search={search}
        />
      ),
      dataIndex: "taxType",
      key: "taxType",
      width: 60,
    },
    {
      title: (
        <SearchMerchant
          query={query}
          title="Үйлчилгээ"
          fieldName="serviceName"
          search={search}
        />
      ),
      dataIndex: "serviceName",
      key: "serviceName",
      width: 250,
    },
    {
      title: (
        <SearchMerchant
          query={query}
          title="Ү/код"
          fieldName="serviceCode"
          search={search}
        />
      ),
      dataIndex: "serviceCode",
      key: "serviceCode",
      width: 100,
    },
    {
      title: (
        <SearchMerchant
          query={query}
          title="Бүтээгдэхүүн код"
          fieldName="taxProductCode"
          search={search}
        />
      ),
      dataIndex: "taxProductCode",
      key: "taxProductCode",
      width: 180,
    },
    {
      title: (
        <SearchMerchant
          query={query}
          title="Хүсэлт"
          select={[
            { value: "ALL", title: "Сонго" },
            { value: "APPROVED", title: "Баталгаажсан" },
            { value: "SENT_REQUEST", title: "Хүсэлт илгээсэн" },
          ]}
          fieldName="approved"
          search={search}
        />
      ),
      dataIndex: "approved",
      key: "approved",
      width: 160,
      render: (e) =>
        e && e == "APPROVED" ? (
          <Tag color="cyan">Баталгаажсан</Tag>
        ) : (
          <Tag color="default">Хүсэлт илгээсэн</Tag>
        ),
    },
    {
      title: (
        <SearchMerchant
          query={query}
          select={[
            { value: "ALL", title: "Сонго" },
            { value: "ACTIVE", title: "Идэвхтэй" },
            { value: "INACTIVE", title: "Идэвхгүй" },
          ]}
          title="Төлөв"
          fieldName="status"
          search={search}
        />
      ),
      dataIndex: "status",
      key: "status",
      width: 100,
      render: (e) =>
        e && e == "ACTIVE" ? (
          <Tag color="cyan">Идэвхтэй</Tag>
        ) : (
          <Tag color="default">Идэвхгүй</Tag>
        ),
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      width: 100,
      render: (e, r) => {
        return (
          <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
            <Button
              type="default"
              onClick={() => editMerchant(r.id)}
              icon={<EditOutlined style={{ color: "#32B7C2" }} />}
            ></Button>
            <Popconfirm
              onConfirm={() => deleteMerchant(r.id)}
              okText="Тийм"
              cancelText="Болих"
              title="Та энэ мерчантыг устгахдаа итгэлтэй байна уу?"
            >
              <Button
                danger
                icon={<DeleteOutlined style={{ color: "red" }} />}
              ></Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];
  const editMerchant = (id) => {
    setEditingMerchantId(id);
    handleShow();
  };
  const deleteMerchant = async (id) => {
    if (id === 1)
      return notification.error({ message: "Энэ мерчантыг устгах боломжгүй!" });
    showLoading();
    const data = await DeleteVatMerchant(merchantId, id);
    if (data) fetchVatMerchant();
    hideLoading();
  };
  useEffect(() => {
    search(query);
  }, [merchantId]);
  const fetchVatMerchant = async (query) => {
    showLoading();
    const data = await GetVatMerchants(merchantId, query);
    if (data) {
      setMerchants(data);
    }
    hideLoading();
  };
  const addMerchant = () => {
    setEditingMerchantId(null);
    handleShow();
  };
  return (
    <div className="vatMerchantListontainer mt-3">
      <Row>
        <div className="addButtonMerchant">
          <Button
            type="primary"
            className={`${bg_button}`}
            onClick={addMerchant}
          >
            Мерчант бүртгэх
          </Button>
        </div>
      </Row>
      <Table
        scroll={{
          x: "max-content",
        }}
        size="small"
        dataSource={merchants}
        columns={columns}
      />

      {showModal && (
        <MerchantAddEdit
          open={showModal}
          close={closeModal}
          vatMerchantId={editingMerchantId}
          refresh={() => search({})}
        />
      )}
    </div>
  );
};

export default MerchantVatMerchant;
